import React, { useContext } from 'react';
import {
	EditVideoCategoryContext,
	IEditVideoCategoryContext,
} from '../../../editVideoCategoryState/editVideoCategoryContext';
import { TranslationForm } from 'components/TranslationForm/TranslationForm';

interface IProps {
	isVisible: boolean;
}

const TranslationsForm: React.FC<IProps> = ({ isVisible }) => {
	const {
		setTranslationTab,
		changeNameTranslation,
		translations,
		selectedTranslationTab,
		fetchedLanguages,
		IDsSelectedLanguages,
	} = useContext<IEditVideoCategoryContext>(EditVideoCategoryContext);
	return (
		<TranslationForm
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			isVisible={isVisible}
			IDsSelectedLanguages={IDsSelectedLanguages}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
			fetchedLanguages={fetchedLanguages}
		/>
	);
};

export default TranslationsForm;
